import { TenantIds } from '@config/tenant-id';
import { EnumSelect } from '@summit/core';
import { UserExperience } from '../shared/user-experience';

export enum ScheduleStatus {
  Active = 0,
  Down = 1,
  NoDispatch = 2,
  TBD = 3,
  Holiday = 4,
  Idle = 5,
  OnCall = 6,
  OffDuty = 7,
  Training = 8,
  Completed = 9,

  //Add On's
  Cancelled = 100,
  ActiveChanged = 101,
  NoShow = 102,
  Weather = 103, //Cancelled due to weather
  EquipmentMove = 104, //down
  Breakdown = 105,
  EquipmentMoveFedEx = 106, //Running
  Maintenance = 107, //Running to tag truck
  Declined = 108,
  Wild = 109,
  AwaitingAck = 110,
  NoOffer = 111,
  SickCall = 112,
  WeatherDeclined = 113
}

const normalList = [
  ScheduleStatus.Active,
  ScheduleStatus.Down,
  ScheduleStatus.NoDispatch,
  ScheduleStatus.TBD,
  ScheduleStatus.Holiday,
  ScheduleStatus.Idle,
  ScheduleStatus.OnCall,
  ScheduleStatus.OffDuty,
  ScheduleStatus.Training,
  ScheduleStatus.Completed
];

export const ScheduleStatusActive = [
  ScheduleStatus.Active,
  ScheduleStatus.ActiveChanged,
  ScheduleStatus.Training,
  ScheduleStatus.Completed,
  ScheduleStatus.EquipmentMoveFedEx,
  ScheduleStatus.Wild,
  ScheduleStatus.AwaitingAck
];
export const ScheduleStatusNoDispatch = [
  ScheduleStatus.NoDispatch,
  ScheduleStatus.Cancelled,
  ScheduleStatus.Weather,
  ScheduleStatus.NoOffer
];
export const ScheduleStatusDown = [
  ScheduleStatus.Down,
  ScheduleStatus.NoShow,
  ScheduleStatus.EquipmentMove,
  ScheduleStatus.Maintenance,
  ScheduleStatus.Breakdown,
  ScheduleStatus.Declined,
  ScheduleStatus.SickCall,
  ScheduleStatus.WeatherDeclined
];

export function GetTenantStatusIdList(ux: UserExperience, all?: boolean): number[] {
  const baseExcludeList = all ? [] : [ScheduleStatus.TBD];
  switch (ux.activeEmployee.tenantID.toUpperCase()) {
    case TenantIds.CAB:
      return EnumSelect.ToIdListFilter(ScheduleStatus, [
        ...normalList,
        ScheduleStatus.Declined,
        ScheduleStatus.WeatherDeclined
      ])
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
    case TenantIds.D_F:
      return EnumSelect.ToIdListFilter(ScheduleStatus, [
        ...normalList,
        ScheduleStatus.Weather,
        ScheduleStatus.WeatherDeclined,
        ScheduleStatus.EquipmentMoveFedEx
      ])
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
    case TenantIds.ESE:
      return EnumSelect.ToIdListFilter(ScheduleStatus, [...normalList, ScheduleStatus.NoOffer, ScheduleStatus.SickCall])
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
    case TenantIds.GGC:
      return EnumSelect.ToIdListFilter(ScheduleStatus, [
        ...normalList,
        ScheduleStatus.Cancelled,
        ScheduleStatus.Declined
      ])
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
    case TenantIds.KTI:
      return EnumSelect.ToIdListFilter(ScheduleStatus, [
        ...normalList,
        ScheduleStatus.Maintenance,
        ScheduleStatus.Weather,
        ScheduleStatus.WeatherDeclined
      ])
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
    case TenantIds.H_C:
      return EnumSelect.ToIdListFilter(ScheduleStatus, [
        ...normalList,
        ScheduleStatus.Cancelled,
        ScheduleStatus.ActiveChanged,
        ScheduleStatus.NoShow
      ])
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
    case TenantIds.Sophia:
      return EnumSelect.ToIdListFilter(ScheduleStatus, [
        ...normalList,
        ScheduleStatus.Weather,
        ScheduleStatus.WeatherDeclined,
        ScheduleStatus.NoShow,
        ScheduleStatus.Cancelled,
        ScheduleStatus.ActiveChanged,
        ScheduleStatus.Breakdown
      ])
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
    case TenantIds.SFG:
      return EnumSelect.ToIdListFilter(ScheduleStatus, [
        ...normalList,
        ScheduleStatus.Weather,
        ScheduleStatus.WeatherDeclined,
        ScheduleStatus.NoShow,
        ScheduleStatus.Cancelled,
        ScheduleStatus.ActiveChanged,
        ScheduleStatus.EquipmentMove,
        ScheduleStatus.Breakdown
      ])
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
    case TenantIds.ST:
      return EnumSelect.ToIdListFilter(ScheduleStatus, [
        ...normalList,
        ScheduleStatus.Cancelled,
        ScheduleStatus.Weather,
        ScheduleStatus.WeatherDeclined,
        ScheduleStatus.NoShow,
        ScheduleStatus.Breakdown,
        ScheduleStatus.Declined
      ])
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
    case TenantIds.T27:
      return EnumSelect.ToIdListFilter(ScheduleStatus, [
        ...normalList,
        ScheduleStatus.Declined,
        ScheduleStatus.Wild,
        ScheduleStatus.AwaitingAck
      ])
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
    default:
      return EnumSelect.ToIdListFilter(ScheduleStatus, normalList)
        .filter((item) => baseExcludeList.indexOf(item) < 0)
        .sort((a, b) => ScheduleStatusOrder[a] - ScheduleStatusOrder[b]);
  }
}

export const ScheduleStatusNonUser = [ScheduleStatus.TBD, ScheduleStatus.Idle];

export const ScheduleStatusMapping: Record<ScheduleStatus, string> = {
  [ScheduleStatus.Active]: 'Running',
  [ScheduleStatus.Down]: 'Down',
  [ScheduleStatus.NoDispatch]: 'No Dispatch',
  [ScheduleStatus.TBD]: 'TBD',
  [ScheduleStatus.Holiday]: 'Holiday',
  [ScheduleStatus.Idle]: 'Idle',
  [ScheduleStatus.OnCall]: 'On Call',
  [ScheduleStatus.OffDuty]: 'Off Duty',
  [ScheduleStatus.Cancelled]: 'Cancelled',
  [ScheduleStatus.ActiveChanged]: 'Running (Alt)',
  [ScheduleStatus.NoShow]: 'No Show',
  [ScheduleStatus.Training]: 'Training',
  [ScheduleStatus.Weather]: 'Weather (CXLD)',
  [ScheduleStatus.EquipmentMove]: 'Equipment Move',
  [ScheduleStatus.Breakdown]: 'Breakdown',
  [ScheduleStatus.Completed]: 'Completed',
  [ScheduleStatus.EquipmentMoveFedEx]: 'Equipment Move',
  [ScheduleStatus.Maintenance]: 'Maintenance',
  [ScheduleStatus.Declined]: 'Declined',
  [ScheduleStatus.Wild]: 'Wild',
  [ScheduleStatus.AwaitingAck]: 'Awaiting Ack.',
  [ScheduleStatus.NoOffer]: 'No Offer',
  [ScheduleStatus.SickCall]: 'Sick Call',
  [ScheduleStatus.WeatherDeclined]: 'Weather (Declined)'
};
export const ScheduleStatusPriority: Record<ScheduleStatus, string> = {
  [ScheduleStatus.Down]: '01',
  [ScheduleStatus.NoShow]: '02',
  [ScheduleStatus.Declined]: '04',
  [ScheduleStatus.SickCall]: '05',
  [ScheduleStatus.EquipmentMove]: '06',
  [ScheduleStatus.Breakdown]: '07',
  [ScheduleStatus.Maintenance]: '08',
  [ScheduleStatus.Idle]: '09',
  [ScheduleStatus.TBD]: '10',
  [ScheduleStatus.Weather]: '11',
  [ScheduleStatus.WeatherDeclined]: '12',
  [ScheduleStatus.Cancelled]: '13',
  [ScheduleStatus.NoDispatch]: '14',
  [ScheduleStatus.NoOffer]: '15',
  [ScheduleStatus.Training]: '16',
  [ScheduleStatus.EquipmentMoveFedEx]: '17',
  [ScheduleStatus.Wild]: '18',
  [ScheduleStatus.AwaitingAck]: '19',
  [ScheduleStatus.ActiveChanged]: '20',
  [ScheduleStatus.Active]: '21',
  [ScheduleStatus.Completed]: '22',
  [ScheduleStatus.OnCall]: '23',
  [ScheduleStatus.Holiday]: '24',
  [ScheduleStatus.OffDuty]: '25'
};

export const ScheduleStatusOrder: Record<ScheduleStatus, number> = {
  [ScheduleStatus.Active]: 1,
  [ScheduleStatus.ActiveChanged]: 2,
  [ScheduleStatus.AwaitingAck]: 3,
  [ScheduleStatus.EquipmentMoveFedEx]: 4,
  [ScheduleStatus.Training]: 5,
  [ScheduleStatus.Wild]: 6,
  [ScheduleStatus.Completed]: 7,
  [ScheduleStatus.SickCall]: 8,
  [ScheduleStatus.Down]: 9,
  [ScheduleStatus.NoShow]: 10,
  [ScheduleStatus.NoOffer]: 11,
  [ScheduleStatus.Declined]: 12,
  [ScheduleStatus.Weather]: 13,
  [ScheduleStatus.WeatherDeclined]: 14,
  [ScheduleStatus.EquipmentMove]: 15,
  [ScheduleStatus.Maintenance]: 16,
  [ScheduleStatus.Breakdown]: 17,
  [ScheduleStatus.NoDispatch]: 18,
  [ScheduleStatus.Cancelled]: 19,
  [ScheduleStatus.TBD]: 20,
  [ScheduleStatus.Holiday]: 21,
  [ScheduleStatus.Idle]: 22,
  [ScheduleStatus.OnCall]: 23,
  [ScheduleStatus.OffDuty]: 24
};
export const ScheduleStatusRouteColor: Record<ScheduleStatus, string> = {
  [ScheduleStatus.Active]: 'green',
  [ScheduleStatus.ActiveChanged]: 'limeGreen',
  [ScheduleStatus.AwaitingAck]: 'limeGreen',
  [ScheduleStatus.Maintenance]: 'grey',
  [ScheduleStatus.Training]: 'limeGreen',
  [ScheduleStatus.EquipmentMoveFedEx]: 'limeGreen',
  [ScheduleStatus.Completed]: 'dimGray',
  [ScheduleStatus.Down]: 'red',
  [ScheduleStatus.EquipmentMove]: 'red',
  [ScheduleStatus.Breakdown]: 'red',
  [ScheduleStatus.NoShow]: 'red',
  [ScheduleStatus.Weather]: 'orange',
  [ScheduleStatus.NoDispatch]: 'orange',
  [ScheduleStatus.Cancelled]: 'orange',
  [ScheduleStatus.TBD]: 'yellow',
  [ScheduleStatus.Holiday]: 'grey',
  [ScheduleStatus.Idle]: 'red',
  [ScheduleStatus.OnCall]: 'on-call',
  [ScheduleStatus.OffDuty]: 'grey',
  [ScheduleStatus.Declined]: 'red',
  [ScheduleStatus.Wild]: 'violet',
  [ScheduleStatus.NoOffer]: 'orange',
  [ScheduleStatus.SickCall]: 'red',
  [ScheduleStatus.WeatherDeclined]: 'red'
};
export const ScheduleStatusExportColor: Record<ScheduleStatus, string> = {
  [ScheduleStatus.Active]: '198754',
  [ScheduleStatus.ActiveChanged]: '32CD32',
  [ScheduleStatus.AwaitingAck]: '32CD32',
  [ScheduleStatus.Wild]: '32CD32',
  [ScheduleStatus.Maintenance]: '6c757d',
  [ScheduleStatus.Training]: '32CD32',
  [ScheduleStatus.EquipmentMoveFedEx]: '32CD32',
  [ScheduleStatus.Completed]: '6c757d',
  [ScheduleStatus.Down]: 'dc3545',
  [ScheduleStatus.NoShow]: 'dc3545',
  [ScheduleStatus.EquipmentMove]: 'dc3545',
  [ScheduleStatus.Breakdown]: 'dc3545',
  [ScheduleStatus.NoDispatch]: 'fd7e14',
  [ScheduleStatus.Weather]: 'fd7e14',
  [ScheduleStatus.Cancelled]: 'fd7e14',
  [ScheduleStatus.TBD]: 'ffc107',
  [ScheduleStatus.Holiday]: '6c757d',
  [ScheduleStatus.Idle]: 'dc3545',
  [ScheduleStatus.OnCall]: '0d6efd',
  [ScheduleStatus.OffDuty]: '6c757d',
  [ScheduleStatus.Declined]: 'dc3545',
  [ScheduleStatus.NoOffer]: 'fd7e14',
  [ScheduleStatus.SickCall]: 'dc3545',
  [ScheduleStatus.WeatherDeclined]: 'dc3545'
};

export const ScheduleStatusDayCss: Record<ScheduleStatus, string> = {
  [ScheduleStatus.Active]: 'active',
  [ScheduleStatus.ActiveChanged]: 'activeOther',
  [ScheduleStatus.AwaitingAck]: 'activeOther',
  [ScheduleStatus.Wild]: 'activeWild',
  [ScheduleStatus.Training]: 'activeOther',
  [ScheduleStatus.Maintenance]: 'holiday',
  [ScheduleStatus.EquipmentMoveFedEx]: 'activeOther',
  [ScheduleStatus.Completed]: 'completed',
  [ScheduleStatus.Down]: 'fail',
  [ScheduleStatus.NoShow]: 'fail',
  [ScheduleStatus.EquipmentMove]: 'fail',
  [ScheduleStatus.Breakdown]: 'fail',
  [ScheduleStatus.NoDispatch]: 'no-dispatch',
  [ScheduleStatus.Cancelled]: 'no-dispatch',
  [ScheduleStatus.Weather]: 'no-dispatch', //Cancelled due to weather
  [ScheduleStatus.TBD]: 'tbd',
  [ScheduleStatus.Holiday]: 'holiday',
  [ScheduleStatus.Idle]: 'idle',
  [ScheduleStatus.OnCall]: 'on-call',
  [ScheduleStatus.OffDuty]: 'holiday',
  [ScheduleStatus.Declined]: 'fail',
  [ScheduleStatus.SickCall]: 'fail',
  [ScheduleStatus.NoOffer]: 'no-dispatch',
  [ScheduleStatus.WeatherDeclined]: 'fail'
};

export const ScheduleStatusRunCss: Record<ScheduleStatus, string> = {
  [ScheduleStatus.Active]: 'active',
  [ScheduleStatus.ActiveChanged]: 'activeOther',
  [ScheduleStatus.AwaitingAck]: 'activeOther',
  [ScheduleStatus.Training]: 'activeOther',
  [ScheduleStatus.Wild]: 'activeWild',
  [ScheduleStatus.Maintenance]: 'holiday',
  [ScheduleStatus.EquipmentMoveFedEx]: 'activeOther',
  [ScheduleStatus.Completed]: 'completed',
  [ScheduleStatus.Down]: 'fail',
  [ScheduleStatus.NoShow]: 'fail',
  [ScheduleStatus.EquipmentMove]: 'fail',
  [ScheduleStatus.Breakdown]: 'fail',
  [ScheduleStatus.Weather]: 'no-dispatch', //Cancelled due to weather
  [ScheduleStatus.NoDispatch]: 'no-dispatch',
  [ScheduleStatus.Cancelled]: 'no-dispatch',
  [ScheduleStatus.TBD]: 'tbd',
  [ScheduleStatus.Holiday]: 'holiday',
  [ScheduleStatus.Idle]: 'idle',
  [ScheduleStatus.OnCall]: 'on-call',
  [ScheduleStatus.OffDuty]: 'holiday',
  [ScheduleStatus.Declined]: 'fail',
  [ScheduleStatus.SickCall]: 'fail',
  [ScheduleStatus.NoOffer]: 'no-dispatch',
  [ScheduleStatus.WeatherDeclined]: 'fail'
};
